module.exports = __webpack_public_path__ + "img/toggle2-off.036f4f26.svg";